<div id="welcome-message-container">
    <p id="welcome-message-title">
        {{
            (canCurrentUserUseSequencing()
                ? 'dashboard.welcome.message.LA.title'
                : 'dashboard.welcome.message.outsideLA.title'
            ) | translate
        }}
    </p>
    <p id="welcome-message-description">
        {{ 'dashboard.welcome.message.description' | translate }}
    </p>

    <img
        id="welcome-message-adn-img"
        width="263"
        height="105"
        [ngSrc]="'assets/images/illustrations/welcome-message-adn-img.png'"
        alt="" />
</div>
